import { QuizzesArticles } from '@/types';
import React, { useCallback } from 'react';
import { Button, Td, Text, Tr } from '@chakra-ui/react';
import parse from 'html-react-parser';

interface Props {
    article: QuizzesArticles;
    /** Legacy + V2: domainId required. sectionId/title only needed when libraryV2Select. */
    onSelectArticle: (domainId: number, sectionId?: number, title?: string) => void;
    /** When true, require section id and pass article title (library VIDEO V2 create). */
    libraryV2Select?: boolean;
}

export const ArticlesListItem = ({ article, onSelectArticle, libraryV2Select = false }: Props) => {
    const { domain } = article;

    const handleArticleSelect = useCallback(() => {
        if (domain?.id == null) {
            return;
        }
        if (libraryV2Select) {
            if (article.id == null) {
                return;
            }
            const title = (domain.title ?? '').replace(/<[^>]*>/g, '').trim();
            onSelectArticle(domain.id, article.id, title);
            return;
        }
        onSelectArticle(domain.id);
    }, [article.id, domain?.id, domain?.title, libraryV2Select, onSelectArticle]);

    return (
        <>
            <Tr>
                <Td>{domain?.id}</Td>
                <Td>
                    <Text noOfLines={2}>
                        {parse(domain?.title)}
                    </Text>
                </Td>
                <Td>
                    {domain?.articleType}
                </Td>
                <Td>
                    <Button
                        colorScheme='brand'
                        color='currentColor'
                        border='1px solid lightgrey'
                        w='107px'
                        size='sm'
                        onClick={handleArticleSelect}
                    >
                        Select
                    </Button>
                </Td>
            </Tr>
        </>
    );
};
